import script from "./RequireContent.vue?vue&type=script&setup=true&lang=js"
export * from "./RequireContent.vue?vue&type=script&setup=true&lang=js"

import "./RequireContent.vue?vue&type=style&index=0&id=266a833d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-266a833d"]])

export default __exports__